// Beşyıldız Peynircilik Configuration

// In development, use empty string (proxy handles it). In production, use full URL.
export const API_URL = import.meta.env.VITE_API_URL || '';
export const API_KEY = import.meta.env.VITE_API_KEY || '';
export const CUSTOMER_NAME = import.meta.env.VITE_CUSTOMER_NAME || 'Beşyıldız Peynircilik';

// Source IDs for Beşyıldız
export const SOURCES = {
  ONLINE_CIRO_TAKIP: 12, // NG_KasaOnlineRapor
  STOK_FIFO: 14, // F0107D0005_SP_StokFifoRaporu
  STOK_MALIYET: 21, // NG_STOK_DEGER_RAPORU
  KASA_HAREKETLERI: 15, // NG_KASA_HAREKETLERI_RAPORU
  BANKALAR: 16, // NG_BANKALAR
  ALACAKLILAR: 18, // NG_CARI_ALACAKLILAR
  BORCLULAR: 19, // NG_CARI_BORCLULAR
  VERILEN_CEKLER: 20, // NG_VERILENCEK
  ALINAN_CEKLER: 23, // NG_ALINAN_CEKLER
  FIRE_HAREKETLERI: 22, // NG_DEPO_FIRE_HAREKETLERI
  GIDERLER: 24, // NG_ALIS_ANALIZ_GIDERLER
  SATIS_KARLILIK: 25, // NG_SATIS_KARLILIK
  TOP_SATIS_STOKLARI: 29, // NG_TOP_SATIS_STOKLARI - En çok satan ürünler (Tutar)
  TOP_SATIS_STOKLARI_SUBE: 30, // NG_TOP_SATIS_STOKLARI_SUBE - En çok satan ürünler (Miktar)
  FAALIYET_RAPORU: 33, // Faaliyet Raporu - Giriş/Çıkış
  CARI_HESAP_EKSTRESI: 34, // NG_CARI_HESAP_EKSTRESI - Cari Hesap Ekstresi
} as const;

// Theme configuration
export const THEME = {
  primaryColor: '#1890ff',
  headerColor: '#001529',
} as const;
